import { ComponentChildren, ComponentChild, Component } from 'preact'
import Icon from '../../assets'
import classnames from 'classnames'

interface ModalProps {
  children: ComponentChildren
  onClose?: () => void
  variant?: 'S' | 'M' | 'L'
  isControl?: boolean
  isHeightAdjustable?: boolean
  direction?: 'vertical' | 'horizontal'
  onBackdropClick?: () => void
  disableScrollLock?: boolean
}

interface ModalHeaderProps {
  icon?: string
  title: string | ComponentChild
}

interface ModalBodyProps {
  children: ComponentChildren
}

interface ModalFooterProps {
  children: ComponentChildren
}

export const ModalHeader = ({ title }: ModalHeaderProps) => (
  <div className='m-modal--header'>
    <h3 className='m-modal--header_title'>
      <strong>{title}</strong>
    </h3>
  </div>
)

export const ModalFooter = ({ children }: ModalFooterProps) => (
  <div className='m-modal--footer'>{children}</div>
)

export const ModalBody = ({ children }: ModalBodyProps) => (
  <div className='m-modal--body'>{children}</div>
)

const ModalContainer = ({
  children,
  onClose,
  variant = 'M',
  isControl = false,
  isHeightAdjustable = true,
  direction = 'vertical',
  onBackdropClick
}: ModalProps) => (
  <div className='o-modal_container'>
    <div className='o-modal--opacity' onClick={onBackdropClick} role='button' />
    <div
      className={classnames(
        'o-modal',
        `o-modal--size-${variant}`,
        `o-modal--direction-${direction}`,
        {
          'o-modal--app-control': isControl,
          'o-modal--app-destination': !isControl,
          'o-modal--app-fix-height': !isHeightAdjustable
        }
      )}
    >
      <span onClick={onClose} role='button'>
        <Icon
          icon='close'
          width={24}
          height={24}
          color='currentColor'
          customClass='o-modal--close'
        />
      </span>
      {children}
    </div>
  </div>
)

class Modal extends Component<ModalProps> {
  componentWillMount() {
    if (this.props.disableScrollLock) {
      document.body.style.overflow = 'hidden'
    }
  }

  componentWillUnmount() {
    if (this.props.disableScrollLock) {
      document.body.style.overflow = 'auto'
    }
  }

  render() {
    return <ModalContainer {...this.props} />
  }
}

export default Modal
